
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { isCallValidAndNotCancelled } from '@t/ajax-wrapper';
import { NU } from '@t/type';
import { vxm } from '@/store';
import { projectApi } from '@/wapi/project-api';
import ProvisionalAdvancementTable from '@c/provisional-advancement/provisional-advancement-table/provisional-advancement-table.vue';
import { IProjectProgressForecastResponse } from '@/entity/project/project-progress-forecast-response';
import { IProjectProgressForecast } from '@/entity/project/project-progress-forecast';
@Component({
    components: {
        ProvisionalAdvancementTable,
    }
})
export default class ProvisionalAdvancementList extends Vue {
    rows: NU<IProjectProgressForecast[]> = [];
    periods: Array<string> = [];
    showTable: boolean = false;

    isBusy: boolean = false;

    get selectedProjectId(): NU<number> {
        return vxm.project.dropdownProject?.id;
    }

    get isReadOnly(): boolean {
        return  vxm.user.isAssociate && !vxm.user.isAdmin && !vxm.user.isStudioManager;
    }

    @Watch('selectedProjectId')
    async selectedProjectIdUpdated(newVal: number, oldVal: number){
        if (newVal && newVal > 0){
            await this.getProgressForecast(newVal);
        }
    }

    async mounted() {
        vxm.app.changeTitleMain("Prévisionnel d'avancement");
        if (this.selectedProjectId && this.selectedProjectId > 0) {
            await this.getProgressForecast(this.selectedProjectId);
        }
    }

    private async getProgressForecast(projectId: number): Promise<void> {
        this.isBusy = true;
        var result = await projectApi.getProgressForecast(projectId);
        if (isCallValidAndNotCancelled<IProjectProgressForecastResponse>(result)) {
            if (result?.datas) {
                this.rows = result.datas.projectProgressForecasts;
                this.periods = result.datas.periods;
                this.showTable = true;
            }
        }
        this.isBusy = false;
    }

    private async updateProgressForecasts(datas: IProjectProgressForecast[]): Promise<void> {
        this.isBusy = true;
        if (this.selectedProjectId && this.selectedProjectId > 0) {
            var result = await projectApi.updateProgressForecast(this.selectedProjectId, datas);
            if (isCallValidAndNotCancelled<IProjectProgressForecastResponse>(result)) {
                if (result?.datas) {
                    this.rows = result.datas.projectProgressForecasts;
                    this.periods = result.datas.periods;
                    this.$bvToast.toast('Enregistrement effectué avec succès', {
                        title: `Prévisionnel d'avancement`,
                        variant: 'success',
                        solid: true
                    });
                }
            }
        }
        this.isBusy = false;
    }
}
